import {ContractRequest, ContractResponse, CreateContract} from "../models";
import {RestService} from "@sinossi/mates-react-library";

export class ContractServices {
    static getFilteredContracts = (request: ContractRequest, callback: any, catchCallback: any) => {
        RestService
            .post<ContractResponse>("/api/contract/filter", request)
            .then(callback)
            .catch(catchCallback)
    }

    static createContract = (request: CreateContract, callback: any, catchCallback: any) => {
        RestService
            .post<any>("/api/contract", request)
            .then(callback)
            .catch(catchCallback)
    }

    static getContract = (contractId: string, callback: any, catchCallback: any) => {
        RestService
            .get<any>(`/api/contract/${contractId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static updateContract = (contractId: string, request: CreateContract, callback: any, catchCallback: any) => {
        RestService
            .put<any>(`/api/contract/${contractId}`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static deleteContract = (contractId: string, callback: any, catchCallback: any) => {
        RestService
            .delete<any>(`/api/contract/${contractId}`)
            .then(callback)
            .catch(catchCallback)
    }

}
